import { setData } from "rivals/shared/utils/qa";

function Instagram({ instagramId }: { instagramId: string }): JSX.Element {
  return (
    <iframe
      allowFullScreen
      allowTransparency
      height="340"
      src={`https://www.instagram.com/p/${instagramId}/embed/captioned/`}
      style={{
        border: "1px solid lightgray",
        maxWidth: "100%",
        overflow: "hidden"
      }}
      title={`instagram-embed-${instagramId}`}
      {...setData("instagram-embed", instagramId)}
    />
  );
}

export default Instagram;
